import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import "../src/styles/global.css";

import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
